import DashboardEnterprise from './DashboardEnterprise'; export default function App() { return <DashboardEnterprise />; }
